require('./passManagerService');
require('../../shared/teamService');

"use strict";

angular.module('app.admin.passManager.passManagerController', [
  'app.admin.passManager.passManagerService',
  'app.shared.teamService'
])
  .filter('accessScopeMaxCount', function () {
    return function (access_scopes, auth_counts, userAccess) {
      return _.filter(
        access_scopes,
        /**
         * @param {UserAccessScope} scope
         * @returns {boolean}
         */
        function (scope) {
          let counts = auth_counts[scope.iaccessscopeid][userAccess.iaccessfunctionid_fk];
          if (counts && counts.max) {
            return true;
          }
        });
    };
  })
  .controller('app.admin.passManager.passManagerController', [
    '$scope',
    '$q',
    '$stateParams',
    'app.admin.passManager.passManagerService',
    'app.shared.teamService',
    function ($scope, $q, $stateParams, passManagerService, teamService) {

      let newAccessMap = {},
        USER_AFFILIATION_TYPE_ID = 2;

      $scope.usedScopes = [];

      let updateAccess = function (user, access, newAccess) {
        let userIndex = _.indexOf($scope.users, user),
          accessIndex = _.indexOf($scope.users[userIndex], access);
        $scope.users[userIndex].access[accessIndex] = newAccess.data;
      };

      $scope.lookupUser = function (user) {
        passManagerService.getUserByEmail($stateParams.teamId, user.login_name)
          .then(function (response) {
            let index = _.indexOf($scope.users, user);
            $scope.users[index] = response.data;
          });
      };

      $scope.addUser = function () {
        $scope.users.push({});
      };

      $scope.addAccess = function (user) {
        if (!user.access) {
          user.access = [];
        }

        user.access.push({
          iisactive: 1,
          iuserid_fk: user.iuserid,
          iuseraffiliationtypeid_fk: USER_AFFILIATION_TYPE_ID,
          iuseraffiliationkeyid_fk: Number($stateParams.teamId)
        });

        if (!newAccessMap[user.iuserid]) {
          newAccessMap[user.iuserid] = []
        }
        newAccessMap[user.iuserid].push(user.access.length - 1)
      };

      $scope.save = function () {
        let promiseList = [];
        $scope.savingAll = true;
        _.forEach($scope.users, function (user, i) {
          promiseList.push($scope.saveUser(user, i));
        });

        $q.all(_.flatten(promiseList))
          .then(function () {
            $scope.savingAll = false;
          });
      };

      $scope.saveUser = function (user, userIndex) {
        let promises = [];
        _.forEach(user.access, function (access, i) {
          let promise,
            method;
          if (_.includes(newAccessMap[user.iuserid], i)) {
            _.remove(newAccessMap[user.iuserid], function (el) {
              return el === i
            });
            method = 'createAccess';
          } else {
            method = 'updateAccess';
          }
          promise = passManagerService[method](access)
            .then(function (response) {
              let data = response.data;

              if (data.error) {
                alert(data.error, user.login_name);
              }

              if (data.access) {
                $scope.users[userIndex].access[i] = data.access;
              }

              if (data.counts) {
                $scope.auth_counts = data.counts;
              }
            });

          promises.push(promise);
        });
        return promises;
      };

      $q.all(
        teamService.getTeam($stateParams.teamId)
          .then(
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              /**
               * @type {Team}
               */
              let team = response.data;
              $scope.team_name = team.strteamname + ' ' + team.strteammascot;
            }
          ),
        passManagerService.getAuthCounts($stateParams.teamId)
          .then(function (response) {
            $scope.auth_counts = response.data.counts;
            $scope.users = _.map(response.data.users, function (user) {
              return user;
            });
          }),
        passManagerService.getUserRoles()
          .then(function (response) {
            $scope.user_roles = response.data;
          }),
        passManagerService.getAccessFunctions()
          .then(function (response) {
            $scope.access_functions = response.data;
          }),
        passManagerService.getAccessScopes()
          .then(function (response) {
            if (Array.isArray(response.data)) {
              let scopes = [];
              _.forEach([3, 2, 1, 99], (scope_id) => {
                _.forEach(response.data, (scope) => {
                  if (scope.iaccessscopeid === scope_id) {
                    scopes.push(scope);
                    return false;
                  }
                });
              });
              $scope.access_scopes = scopes;
            }
            else {
              $scope.access_scopes = null;
            }
          }))
        .then(function () {
          $scope.$applyAsync(function () {
            $scope.showTable = true;
          });
        });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/passManager/passManagerController.js